/**
 * Utilidades de tracking para Zaraz que pueden usarse fuera de componentes React
 */

interface ZarazUser {
  user_id?: string;
  email?: string;
  name?: string;
  role?: string;
}

/**
 * Envía un evento a Zaraz
 */
export const trackEvent = (eventName: string, parameters: Record<string, any> = {}) => {
  if (typeof window !== 'undefined' && (window as any).zaraz) {
    try {
      (window as any).zaraz.track(eventName, parameters);
      console.log(`[Zaraz] Evento enviado: ${eventName}`, parameters);
    } catch (error) {
      console.error(`[Zaraz] Error enviando evento ${eventName}:`, error);
    }
  } else {
    console.warn(`[Zaraz] Zaraz no disponible para el evento: ${eventName}`);
  }
};

/**
 * Track cuando un usuario inicia sesion
 */
export const trackSignedIn = (userData: ZarazUser) => {
  trackEvent('Signed In', {
    user_id: userData.user_id,
    email: userData.email,
    name: userData.name,
    role: userData.role
  });
};

/**
 * Track cuando un usuario cierra sesion
 */
export const trackSignedOut = (userData?: ZarazUser) => {
  trackEvent('Signed Out', {
    user_id: userData?.user_id,
    email: userData?.email
  });
};
